import { useSession } from "@/hooks/@custom/useSession";
import { Role } from "@/store";
import { useGetQueueTotalsByCompanyQuery } from "@/store/apis/nextcargo";

import { ExpeditionQueueStatusBox, ServiceStatusBox } from "./ExpeditionQueueStatusBox/ExpeditionQueueStatusBox";

export function ExpeditionQueueStatus() {
  const { expedition } = useSession();
  const companyId = Number(expedition?.company.id);
  const role = expedition?.role;

  const { data: queueStatus } = useGetQueueTotalsByCompanyQuery({ id: companyId }, { skip: !companyId });

  const isConciergeViewer = role === Role.Portaria;
  const queueTransportedToday = queueStatus?.totalTransportedToday?.toString().substring(0, 4) || 0;

  if (!queueStatus) return null;

  // TODO implementar prefetch quando o usuário efetua um evento de hover em um card
  const serviceStatus: ServiceStatusBox[] = [
    {
      key: "default",
      title: "Toneladas Programadas",
      value: queueStatus?.totalPlannedToday,
      isVisible: true
    },
    {
      key: "scheduled",
      title: "Veículos Programados",
      value: queueStatus?.totals,
      isVisible: true
    },
    {
      key: "courtyard",
      title: "Veículos no Pátio",
      value: queueStatus.checkinsToday,
      isVisible: true
    },
    {
      key: "attended",
      title: "Veículos Atendidos",
      value: queueStatus?.attended,
      isVisible: !isConciergeViewer,
      onMouseEnter: () => {
        console.log("Hover attended");
      }
    },
    {
      key: "tons",
      title: "Toneladas Expedidas",
      value: typeof queueTransportedToday === "string" ? queueTransportedToday.replaceAll(".", "") : queueTransportedToday,
      isVisible: !isConciergeViewer
    },
    {
      key: "missing",
      title: "Veículos Faltosos",
      value: queueStatus?.missing,
      isVisible: true,
      onMouseEnter: () => {
        console.log("Hover missing");
      }
    },
    {
      key: "dropout",
      title: "Veículos Desistentes",
      value: queueStatus?.dropouts,
      isVisible: true,
      onMouseEnter: () => {
        console.log("Hover dropout");
      }
    }
  ];

  return (
    <div className="xs:grid-cols-3 grid grid-cols-2 items-start gap-2 sm:grid-cols-4 md:grid-cols-7">
      {serviceStatus.map((service, i) => (
        <ExpeditionQueueStatusBox key={i} service={service} />
      ))}
    </div>
  );
}
